import { createContext, useContext } from 'react'

export type AuthSessionUser = {
    id: string
    email: string
}

export type AuthContextValue = {
    user: AuthSessionUser | null
    loading: boolean
    error?: string
    refresh: () => Promise<void>
    loginWithPassword: (
        email: string,
        password: string,
        recaptchaToken?: string,
    ) => Promise<void>
    requestMagicLink: (
        email: string,
        recaptchaToken?: string,
        target?: string,
    ) => Promise<void>
    magicLogin: (token: string) => Promise<void>
    logout: () => Promise<void>
}

export const AuthContext = createContext<AuthContextValue | undefined>(
    undefined,
)

export function useAuth(): AuthContextValue {
    const ctx = useContext(AuthContext)
    if (!ctx) {
        throw new Error('useAuth must be used within AuthProvider')
    }
    return ctx
}
